(() => {
  'use strict';
  if (window.decorPalaceNivaLoader) return;
  window.decorPalaceNivaLoader = true;
  let loading;
  const suppressed = () => { if(window.decorPalaceNivaDismissed)return true;try { return sessionStorage.getItem('niva-dismissed') === '1'; } catch { return false; } };
  async function open(root) {
    if (!root || !root.isConnected) return;
    if (!customElements.get('niva-concierge')) {
      if (!loading) loading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = root.dataset.script; script.defer = true;
        script.onload = resolve; script.onerror = () => { script.remove(); loading = null; reject(new Error('NIVA unavailable')); };
        document.head.append(script);
      });
      try { await loading; await customElements.whenDefined('niva-concierge'); }
      catch { const status = root.querySelector('[data-niva-boot]'); if (status) status.textContent = 'NIVA could not open. Please try again.'; return; }
    }
    if (root.isConnected) { root.querySelector('[data-niva-boot]').textContent = ''; root.open(); }
  }
  function setup() {
    document.querySelectorAll('[data-niva-root]:not([data-niva-ready])').forEach(root => {
      root.dataset.nivaReady = 'true';
      root.querySelectorAll('[data-niva-character]').forEach(img => {
        const fallback = () => { img.hidden = true; img.nextElementSibling.hidden = false; };
        img.addEventListener('error', fallback, {once:true}); if (img.complete && !img.naturalWidth) fallback();
      });
      if (root.dataset.auto !== 'true' || root.dataset.editor === 'true' || suppressed()) return;
      const mobile = matchMedia('(max-width:749px)').matches;
      if (root.dataset.devices === 'desktop' && mobile || root.dataset.devices === 'mobile' && !mobile) return;
      setTimeout(() => {
        if (!root.isConnected || suppressed() || document.hidden || document.querySelector('dialog[open],[aria-modal="true"]')) return;
        window.decorPalaceNivaDismissed=true;
        try { sessionStorage.setItem('niva-dismissed', '1'); } catch { /* Memory stays local when storage is unavailable. */ }
        open(root);
      }, Math.max(8, Number(root.dataset.delay) || 12) * 1000);
    });
    position();
  }
  function position() {
    const viewport = window.visualViewport;
    document.querySelectorAll('[data-niva-root]').forEach(root => {
      root.style.setProperty('--nv-view-height', (viewport?.height || innerHeight) + 'px');
      root.style.setProperty('--nv-keyboard', Math.max(0, innerHeight - (viewport?.height || innerHeight) - (viewport?.offsetTop || 0)) + 'px');
      root.style.setProperty('--nv-obstruction', '0px');
      const anchor = root.querySelector('[data-niva-open]');
      if (!anchor || anchor.hidden) return;
      const r = anchor.getBoundingClientRect(); let extra = 0;
      document.querySelectorAll('a[href*="wa.me"],a[href*="api.whatsapp.com"],[id*="cookie-banner"],[class*="cookie-banner"],sticky-add-to-cart,.sticky-add-to-cart,[id*="accessibility-widget"]').forEach(el => {
        if (root.contains(el)) return;
        const b = el.getBoundingClientRect(), style = getComputedStyle(el);
        if (!b.width || !b.height || style.visibility === 'hidden' || b.top > innerHeight || b.bottom < innerHeight * .55) return;
        if (b.left < r.right && b.right > r.left && b.top < r.bottom && b.bottom > r.top) extra = Math.max(extra, r.bottom - b.top + 12);
      });
      root.style.setProperty('--nv-obstruction', Math.min(extra, innerHeight * .3) + 'px');
    });
  }
  document.addEventListener('click', e => { const button = e.target.closest('[data-niva-open]'); if (button && !button.closest('[data-niva-root]').ready) open(button.closest('[data-niva-root]')); });
  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:select', e => { const root = e.target.querySelector('[data-niva-root]'); if (root) open(root); });
  document.addEventListener('shopify:block:select', e => { const root = e.target.closest('[data-niva-root]'); if (root) open(root); });
  window.addEventListener('resize', position, {passive:true});
  window.visualViewport?.addEventListener('resize', position, {passive:true});
  window.visualViewport?.addEventListener('scroll', position, {passive:true});
  window.addEventListener('load', position, {once:true});
  setup();
})();
